<h4 class="w-100">
  {{ title ? title : '&nbsp;' }}
  <jhi-bary-icon icon="cog" [faDirective]="FAS" size="sm" class="float-right color-primary invert cursor" (click)="frame.show()"></jhi-bary-icon>
</h4>
<div>
  <div mdbModal #frame="mdbModal" class="modal fade left" id="frameModalTop" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header text-center">
          <h4 class="modal-title w-100 font-weight-bold">Statistiques à afficher</h4>
        </div>
        <div class="modal-body mx-3 row">
          <div class="col">
            <select [(ngModel)]="firstSelect" class="browser-default custom-select">
              <option *ngFor="let counter of countersList" [value]="counter">
                {{ setCounterLabel(counter) | translate }}
              </option>
            </select>
          </div>
          <div class="col">
            <select [(ngModel)]="secondSelect" class="browser-default custom-select">
              <option *ngFor="let counter of countersList" [value]="counter">
                {{ setCounterLabel(counter) | translate }}
              </option>
            </select>
          </div>
          <div class="col">
            <select [(ngModel)]="thirdSelect" class="browser-default custom-select">
              <option *ngFor="let counter of countersList" [value]="counter">
                {{ setCounterLabel(counter) | translate }}
              </option>
            </select>
          </div>
        </div>
        <div class="row">
          <div class="col my-3">
            <jhi-bary-button label="{{ 'BTN.SUBMIT' | translate }}" (clickEvent)="showCountersWithList(); frame.hide()" class="pxtra-3 float-right mx-3" size="sm" color="success">
            </jhi-bary-button>
            <jhi-bary-button label="{{ 'BTN.CANCEL' | translate }}" (clickEvent)="frame.hide()" class="pxtra-3 float-right" size="sm" color="danger"> </jhi-bary-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="row align-items-baseline my-4" *ngIf="setOfCards.length > 0">
  <div class="col-xl col-md-6 mb-3" *ngFor="let card of setOfCards">
    <jhi-bary-card [cascade]="true" class="cascading-admin-card">
      <div body>
        <div class="admin-up">
          <jhi-bary-icon *ngIf="card.icon" [icon]="card.icon" [faDirective]="FAS" class="primary-color"></jhi-bary-icon>
          <div class="data">
            <h4>
              <strong>{{ card.value | number: setCounterPrecision(card.precision) }}</strong
              ><span> {{ card.unit }}</span>
            </h4>
          </div>
        </div>
        <p>
          {{ setCounterLabel(card.key) | translate }}
        </p>
      </div>
    </jhi-bary-card>
  </div>
</div>
